export default {
    list: [
        {
        "id": "1712558913136",
        "parent_id": null,
        "name": "Frantoio",
        "sort": 0,
        "create_time": "2024-04-23T05:54:03.000Z",
        "children": [
                {
                    "id": "1773728964888",
                    "parent_id": "1712558913136",
                    "name": "Frantoio",
                    "sort": 0,
                    "create_time": "2026-03-17T06:29:25.000Z"
                }
            ]
        }
    ]
}